import { colorPalette } from '../../../../style/colorPalette'

// 編集不可セルの背景色（commons/AgGrid/cellStyle.ts の GRAYED_OUT_STYLE と同色）。
export const DISABLE_COLOR = colorPalette.monotone[1]
